module.exports = __webpack_public_path__ + "img/1.9d9f4b88.jpg";